import { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { removeAlert } from "../redux/reducers/Alerts";
import { sendPageViewToBackend } from "./api";

type ReduxProps = {
  removeAlert: () => any;
};

const RouteChangeHandler: React.FC<ReduxProps & RouteComponentProps> = ({
  history,
  removeAlert,
}) => {
  useEffect(() => {
    removeAlert();

    const path = history.location.pathname;
    const search = history.location.search;
    const fullPath = `${path}${search}`;
    sendPageViewToBackend(fullPath);
  }, [history.location.pathname, history.location.search]);

  return null;
};

export default connect(null, {
  removeAlert,
})(withRouter(RouteChangeHandler));
